module.exports = __webpack_public_path__ + "static/img/new.2dd3f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/new.png
// module id = aICI
// module chunks = 0